export const status = {

    'status': [{
        'id': 'ACTIVE',
        'value': 'Active'
    },
    {
        'id': 'SUSPENDED',
        'value': 'Suspend'
    },
    {
        'id': 'REJECTED',
        'value': 'Reject'
    }]
}

export const industryType = {
    'type': [{
        'id': 'SMB',
        'value': 'SMB'
    },
    {
        'id': 'CORP',
        'value': 'Corporate.'

    }]
}

export const segments = {
    'segment': [
        {
            'id': 'Micro',
            'value': 'Micro'
        },
        {
            'id': 'SMB',
            'value': 'SMB'
        },
        {
            'id': 'Corporate',
            'value': 'Corporate'
        },
        {
            'id': 'Enterprise',
            'value': 'Enterprise'
        },
        {
            'id': 'Edutech',
            'value': 'Edutech'
        },
        {
            'id': 'Startup',
            'value': 'Startup'
        }, {
            'id': 'Education',
            'value': 'Education'
        }
    ]
}

export const zones = {
    'zone': [
        {
            'id': 'North',
            'value': 'North'
        },
        {
            'id': 'West',
            'value': 'West'
        },
        {
            'id': 'South',
            'value': 'South'
        },
    ]
}

export const highlight = {
    'comment': [
        {
            'id': 'Green',
            'value': 'Green'
        }, {
            'id': 'Orange',
            'value': 'Orange'
        }, {
            'id': 'Red',
            'value': 'Red'
        }
    ]
}

export const comment_status = {
    'status': [
        {
            'id': 'Confirmation Received',
            'value': 'Confirmation Received'
        },

        {
            'id': 'In Discussion',
            'value': 'In Discussion'
        },

        {
            'id': 'Partial Upgrade',
            'value': 'Partial Upgrade'
        },

        {
            'id': 'Lost',
            'value': 'Lost'
        },

        {
            'id': 'Upgrade',
            'value': 'Upgrade'
        },

        {
            'id': 'Move To Axima',
            'value': 'Move to axima'
        },

        {
            'id': 'Suspended',
            'value': 'Suspended'
        },

        {
            'id': 'Confirmation received for flex',
            'value': 'Confirmation received for flex'
        },

        {
            'id': 'Mid Term Upgrade',
            'value': 'Mid Term Upgrade'
        },

        {
            'id': 'Extension',
            'value': 'Extension'
        },
        {
            'id': 'Moved to O365',
            'value': 'Move to 0365 with other Vendor'

        }
    ]
}

export const aggrement_status = {
    'status': [
        {
            'id': 'Sent',
            'value': 'Sent'
        },
        {
            'id': 'Signed',
            'value': 'Signed'
        },
        {
            'id': 'Pending',
            'value': 'Pending'
        }, {
            'id': 'N/A',
            'value': 'N/A'
        }
    ]
}

export const yesno = {
    'options': [{
        'id': 'Yes',
        'value': 'Yes'
    },
    {
        'id': 'No',
        'value': 'No'
    }
    ]
}

export const reason = {
    'reasons': [{
        'id': 'Move to other vendor',
        'value': 'Move to other vendor'
    },
    {
        'id': 'Move to other service',
        'value': 'Move to other service'
    }
    ]
}

export const sub_reason = {
    'sub_reasons': [{
        'id': 'Price Issue',
        'value': 'Price Issue'
    },
    {
        'id': 'Support Issue',
        'value': 'Support Issue'
    }
    ]
}

export const axima_billing_frequency = {
    'billing_frequency': [{
        'id': 'Monthly Monthly',
        'value': 'Monthly Monthly'
    },{
        'id': 'Monthly Annual',
        'value': 'Monthly Annual'

    },{
        'id': 'Annual',
        'value': 'Annual'
    }]
}

export const notification_type = {
    'type': [{
        'id': 'Actual Renewal',
        'value': 'Actual Renewal'
    },
    {
        'id': '24 months',
        'value': '24 months'
    },
    {
        'id': '36 months',
        'value': '36 months'
    },
    {
        'id': 'PDL',
        'value': 'PDL'

    }]
}

export const suspension_reason = {
    'reason': [{
        'id': 'No confirmation',
        'value': 'No confirmation'
    },{
        'id': 'Business Closed',
        'value': 'Business Closed'
    },{
        'id': 'Confirmation recd not paid',
        'value': 'Confirmation recd not paid'
    },{
        'id':'Client is not using the services',
        'value':'Client is not using the services'
    },{
        'id':'Downgraded in another SKU',
        'value':'Downgraded in another SKU'
    },{
        'id':'Upgarded in another SKU',
        'value':'Upgarded in another SKU'
    },{
        'id':'Migrated in New domain',
        'value':'Migrated in New domain'
    },{
        'id':'Others',
        'value':'Others'
    }]
}

export const support_packages = {
    'support_packages': [{
        'id': 'Basic',
        'value': 'Basic'
    }, {
        'id': 'Standard',
        'value': 'Standard'
    },{
        'id': 'Professional',
        'value': 'Professional'
    }]
}  

export const managed_service_type = {
    'managed_service_type':[{
        'id': 'Dedicated Remote',
        'value': 'Dedicated Remote'
    },{
        'id':'Dedicated Onsite',
        'value': 'Dedicated Onsite'
    },{
        'id':'Ent(Remote Shared)',
        'value':'Ent(Remote Shared)'
    }]
}

export const managed_service_price = {
    'managed_service_price':[
        {
            'id': 'Paid',
            'value': 'Paid'
        },
        {
            'id': 'Un Paid',
            'value': 'Un Paid'
        }
    ]
}

export const deployment_status = {
    'deployment_status':[{
        'id': 'Done',
        'value': 'Done'
    },{
        'id': 'Error',
        'value': 'Error'
    },{
        'id': 'In-Progress',
        'value': 'In-Progress'
    },{
        'id': 'On-Hold',
        'value': 'On-Hold'
    },{
        'id': 'Cancelled',
        'value': 'Cancelled'
    
    }]

}

export const license_filter = {
    'license_filter':[{
        'id': '< 99',
        'value': '< 99'},
    {
        'id':'100-300',
        'value':'100-300'
    },
        {
            'id':'301-999',
            'value':'301-999'
        },
        {
            'id':'1000+',
            'value':'1000+'
        }
    ]
}

export const support_frequency = {
    'support_frequency': [{
        'id': 'Monthly',
        'value': 'Monthly'
    },{
        'id': 'Quarterly',
        'value': 'Quarterly'
    },{
        'id': 'Half-Yearly',
        'value': 'Half-Yearly'
    },
    {
        'id': 'Annual',
        'value': 'Annual'
    }
]
}